import { RotateCw } from "lucide-react";
import { useDiscountUpdate } from "@/hooks/useDiscountUpdate";
import { generateCouponCode } from "@/services/discountService";
import { useAppSelector } from "@/store/hooks";
import { PageType, TabType } from "@/types/coupon/discount";
import { useState } from "react";
import { ButtonPrimary } from "../common/ButtonPrimary";
import { StandardFormInput } from "../common/StandardFormInput";

interface GenerateCouponResponse {
  data: string;
  message: string;
  valid: boolean;
  success: boolean;
  status: number;
}

const DiscountCode = ({
  currentTab,
  currentPage,
}: {
  currentTab: TabType;
  currentPage: PageType;
}) => {
  const handleUpdate = useDiscountUpdate();
  const discountCode = useAppSelector(
    (state) => state.discount[currentPage].discount_code,
  );
  const discountTitle = useAppSelector(
    (state) => state.discount[currentPage].title,
  );
  const [loading, setLoading] = useState(false);
  const handleGenerateCode = async () => {
    setLoading(true);
    try {
      const res = (await generateCouponCode()) as GenerateCouponResponse;
      console.log("[DiscountCode] Generate response:", res);
      console.log("[DiscountCode] Generated code:", res.data);
      handleUpdate(currentPage, { discount_code: res.data });
    } catch (err) {
      console.error("Failed to generate coupon code:", err);
    } finally {
      setLoading(false);
    }
  };

  const isDiscountCodeMethod = currentTab === "code";

  const handleInputChange = ({
    field,
    value,
  }: {
    field: string;
    value: string;
  }) => {
    handleUpdate(currentPage, { [field]: value });
  };

  return (
    <div className="">
      {isDiscountCodeMethod ? (
        <div className="space-y-1">
          <label className="block text-[13px] font-normal text-muted-foreground mb-1">
            Discount Code
          </label>
          <div className="flex items-center gap-2">
            <div className="flex-1 bg-background border border-border rounded-xl overflow-hidden">
              <input
                type="text"
                placeholder="Enter discount code"
                value={discountCode}
                onChange={(e) => {
                  handleInputChange({
                    field: "discount_code",
                    value: e.target.value,
                  });
                }}
                className="w-full px-4 py-2 h-[38px] bg-transparent placeholder-gray-500 outline-none"
              />
            </div>
            <ButtonPrimary
              onClick={handleGenerateCode}
              className="h-[38px] shrink-0"
              disabled={loading}
            >
              {loading ? "Generating..." : "Generate"}{" "}
              <RotateCw className="w-4 h-4 ml-2" />
            </ButtonPrimary>
          </div>
          <span className="text-[13px] font-normal text-muted-foreground">
            Customers must enter this code at checkout
          </span>
        </div>
      ) : (
        <StandardFormInput
          label="Title"
          type="text"
          placeholder="Enter discount title"
          value={discountTitle}
          onChange={(e) => {
            handleInputChange({
              field: "title",
              value: e.target.value,
            });
          }}
          helperText="Internal name for this discount"
        />
      )}
    </div>
  );
};

export default DiscountCode;
